import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { axiosInstance } from '../../utils/axiosInterceptor';
import OutsideClickHandler from 'react-outside-click-handler';

export const getLinkVacancy = (vacancy) => {
  if (vacancy?.is_active && !vacancy?.is_verified) {
    return `/moderation/${vacancy?.id}`;
  } else {
    return `/activation/${vacancy?.id}`;
  }
};

export default function OtherFeedbacks({ userId, count, appId }) {
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  const [items, setItems] = useState([]);
  const [data, setData] = useState();
  const page = useRef(1);
  const onFetchApplications = () => {
    axiosInstance
      .get(`${process.env.REACT_APP_SERVER_API}/vacancies/applications`, {
        params: { page: page.current, candidate_id: userId },
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      })
      .then((res) => {
        setItems((prev) => [...prev, ...res.data.results]?.filter((item) => item?.id !== appId));
        setData(res.data);
      });
  };
  console.log(items);

  //   const [open, setOpen] = useState(false);
  const handleOpen = (open) => {
    // setOpen(open);
    if (open) {
      onFetchApplications();
    } else {
      setData();
      setItems([]);
      page.current = 1;
    }
  };

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setData();
        setItems([]);
        page.current = 1;
      }}>
      {' '}
      <Menu as="div" className="relative inline-block text-left">
        {({ open }) => {
          return (
            <>
              {' '}
              <div>
                <Menu.Button
                  onClick={(e, t) => {
                    console.log(!open);

                    handleOpen(!open);
                  }}
                  className="inline-flex w-full justify-center  gap-x-1.5 rounded-md  px-2.5 py-1 bg-gray-300 text-sm font-semibold text-gray-900">
                  Другие отклики ({count})
                  <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" fill="currentColor" className="bi bi-caret-down-fill self-center" viewBox="0 0 16 16">
                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"></path>
                  </svg>
                </Menu.Button>
              </div>
              <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-scroll py-1 max-h-[120px] " id={'other-list'}>
                  <InfiniteScroll
                    className=""
                    dataLength={items.length - 1}
                    scrollableTarget="other-list"
                    next={() => {
                      console.log('next');
                      if (data?.next) {
                        page.current += 1;
                        onFetchApplications();
                        //   dispatch(getEmployerList({ ...activeEmployerFilter.params, name: textEmployerFilter, page: page.current, ...(sortEmployerList && { ordering: 'id' }) }));
                      }
                    }}
                    hasMore={true}>
                    {items.map((item) => (
                      <Menu.Item>
                        {({ active }) => (
                          <Link to={getLinkVacancy(item?.vacancy)} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                            {item?.id} {item?.vacancy?.name}
                          </Link>
                        )}
                      </Menu.Item>
                    ))}
                  </InfiniteScroll>
                  {/* <div className="py-1 max-h-[100px] " style={{ overflow: 'scroll' }}></div> */}
                </Menu.Items>
              </Transition>
            </>
          );
        }}
      </Menu>
    </OutsideClickHandler>
  );
}
